import { render, staticRenderFns } from "./Showu.vue?vue&type=template&id=08eeca7d&"
import script from "./Showu.vue?vue&type=script&lang=js&"
export * from "./Showu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports